import { render } from "./BeneficiariesTable.vue?vue&type=template&id=63f5da54&ts=true"
import script from "./BeneficiariesTable.vue?vue&type=script&lang=ts"
export * from "./BeneficiariesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__